/**
 * Whether a write would send anything new.
 *
 * `JSON.stringify` rather than a deep-equality helper: both sides are built by the SAME function, so
 * key order is identical by construction, and what is compared is the payload itself — the object the
 * API or Hasura receives as JSON. Comparing exactly what goes on the wire is the point; comparing a
 * hand-listed set of fields is the version of this that silently stops saving something.
 *
 * No baseline means write. That is the state after a failed snapshot, and "save everything" is the
 * only safe answer to "I do not know what changed": a wasted call costs a round trip, a skipped one
 * costs the user their edit.
 *
 * Extracted so the four writes a save fans out into can share one rule. Three of them did not have
 * it, and the cost was not only the requests: `insertProjectTransport` and
 * `updateProjectActiveBranches` each write a `project_version` row, so every save of any field
 * logged "Transport updated" and "Branches updated" next to it. A project whose name had been edited
 * five times had thirty-two history entries, most of them describing changes nobody made.
 */
export const payloadChanged = <T>(next: T, previous: T | null | undefined): boolean =>
  previous === null || previous === undefined || JSON.stringify(next) !== JSON.stringify(previous);

export default payloadChanged;
